import { gql } from '@apollo/client';

export const GET_BATCH_REPORT_DOWNLOAD_URLS = gql`
  query ReportQuery($reportIds: [Long!]!, $warehouseId: Long!) {
    getBatchReportDownloadUrlsForWms(reportIds: $reportIds, warehouseId: $warehouseId)
  }
`;

export interface GetBatchReportDownloadUrlsResponse {
  getBatchReportDownloadUrlsForWms: string[];
}

export interface GetBatchReportDownloadUrlsVariables {
  reportIds: number[];
  warehouseId: number;
}